import { groupBy, sortBy } from 'lodash'

const CATEGORY_ORDER = [
  'Introduction',
  'Primitives',
  'Layout',
  'General',
  'Images',
  'Indicators',
  'Overlays',
  'Forms',
]

export const getSortedCategories = (categories) => {
  const groupedCategories = groupBy(
    categories,
    (categories) => categories.category
  )
  return CATEGORY_ORDER.map((key) => ({
    category: key,
    components: sortBy(
      sortBy(groupedCategories[key], [(component) => component.title]),
      [(component) => (component.order === undefined ? 0 : component.order)]
    ),
  }))
}
